// SignupStep4.jsx — Country + Accept Terms
import React from "react";
import { COUNTRIES } from "../../constants/formData";

// Normalizes COUNTRIES to always be { value, label } pairs, regardless of
// whether constants/formData.js exports it as an array of plain strings
// (e.g. ["USA", "India", ...]) or already as { value, label } objects.
function normalizeCountries(list) {
  if (!Array.isArray(list)) return [];
  return list.map((entry) =>
    typeof entry === "string" ? { value: entry, label: entry } : entry
  );
}

const countryOptions = normalizeCountries(COUNTRIES);

const SignupStep4 = ({ formData, setFormData, nextStep, prevStep }) => {
  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;
    setFormData({ ...formData, [name]: type === "checkbox" ? checked : value });
  };

  const canContinue = formData.country && formData.acceptedTerms;

  return (
    <div className="step4">
      <div className="left-icon1">
        <button type="button" className="backbutton" onClick={prevStep}>
          <i className="fa fa-long-arrow-left" aria-hidden="true"></i>
        </button>
      </div>
      <div className="icon-blk text-center">
        <img src="images/profile-icon.svg" alt="Profile" />
      </div>
      <div className="form-basic">
        <h5 className="modal-title">Where are you located?</h5>
        <div className="mb-3">
          <div className="select-control">
            <select
              className="form-control"
              name="country"
              value={formData.country}
              onChange={handleChange}
            >
              <option value="">Select Country</option>
              {countryOptions.map((country) => (
                <option key={country.value} value={country.value}>
                  {country.label}
                </option>
              ))}
            </select>
          </div>
        </div>

        <div className="mb-3" style={{ display: "flex", alignItems: "flex-start", gap: 8 }}>
          <input
            type="checkbox"
            id="acceptTerms"
            name="acceptedTerms"
            checked={formData.acceptedTerms}
            onChange={handleChange}
          />
          <label htmlFor="acceptTerms" style={{ fontSize: 12 }}>
            I agree to the{" "}
            <a href="/terms-and-conditions" target="_blank" rel="noopener noreferrer">Terms of Service</a>{" "}
            and{" "}
            <a href="/privacy-policy" target="_blank" rel="noopener noreferrer">Privacy Policy</a>.
          </label>
        </div>

        <div className="modal-footer border-0 justify-content-center p-0 footer-modal mt-4">
          <button
            type="button"
            className="py-2 btn-filled"
            onClick={nextStep}
            disabled={!canContinue}
          >
            Continue
          </button>
        </div>
      </div>
    </div>
  );
};

export default SignupStep4;